import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			margin: theme.spacing(0, -2),
			transition: theme.transitions.create(['margin-top', 'margin-bottom']),
			[theme.breakpoints.down('sm')]: {
				marginTop: ({ metaData: { marginTop } }) =>
					marginTop?.toNumber() ? theme.spacing(-marginTop?.toNumber() / 18) : null,

				marginBottom: ({ metaData: { marginBottom } }) =>
					marginBottom?.toNumber() > 0 ? theme.spacing(-marginBottom?.toNumber() / 18) : null,
			},
			[theme.breakpoints.only('sm')]: {
				margin: theme.spacing(0, -3),
			},
			[theme.breakpoints.up('md')]: {
				margin: 0,
			},
		},
		paper: {
			borderRadius: 0,
			padding: theme.spacing(5, 0),
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(10, 0),
			},
		},
		content: {
			maxWidth: '100%',
		},
	}),
	{ name: 'CallToAction-Cta2' },
)

export default useStyles
